// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"_84c10b","mainImage":"_2ca567"};